import LineClamp from '@space-core/components/lineClamp'

import ContentLoader from '@space-shell/common/components/contentLoader'

import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'
import { t } from 'i18next'

import { LogoContainer, LogoHighlight, LogoImage } from './styles'
import type { LogoProps } from './types'

const Logo = ({
  isLoading,
  membershipName,
  defaultLogoUrl,
  logoAltText,
  previewLogoUrl,
  isSessionPreviewEnable,
  membershipPreviewName,
  handleClickLogo
}: LogoProps) => {
  const { showHeaderHighlight } = useParentInfoStore()

  if (isLoading) {
    return (
      <div className='_d-flex _align-items-center'>
        <ContentLoader loaderSize />
      </div>
    )
  }

  if (isSessionPreviewEnable) {
    return (
      <>
        {previewLogoUrl ? (
          <LogoImage
            loading='eager'
            objectFit='contain'
            className='_max-h-full _h-auto'
            src={previewLogoUrl}
            alt={membershipPreviewName}
          />
        ) : (
          <>
            <LogoContainer
              className='_position-relative _px-4'
              $isPreview={isSessionPreviewEnable}
              $showHeaderHighlight={showHeaderHighlight}>
              <LineClamp className='_text-gray-900'>{membershipPreviewName}</LineClamp>
              {showHeaderHighlight && (
                <LogoHighlight className='_text-white _px-2 _bg-blue _rounded-bottom _d-flex _align-items-center _justify-content-center'>
                  <span className='_test-1'>{t('preview.highlights.logo')}</span>
                </LogoHighlight>
              )}
            </LogoContainer>
          </>
        )}
      </>
    )
  }

  return (
    <a
      href='/'
      aria-label='logo'
      onClick={handleClickLogo}
      data-test='logo-link'
      className='_text-decoration-none _max-h-full'>
      {defaultLogoUrl ? (
        <LogoImage
          loading='eager'
          objectFit='contain'
          className='_max-h-full'
          src={defaultLogoUrl}
          alt={logoAltText ?? membershipName}
        />
      ) : (
        <LineClamp className='_text-gray-900'>{membershipName}</LineClamp>
      )}
    </a>
  )
}

export default Logo
